import { render, staticRenderFns } from "./swiperAdd.vue?vue&type=template&id=3f461b15&scoped=true"
import script from "./swiperAdd.vue?vue&type=script&lang=js"
export * from "./swiperAdd.vue?vue&type=script&lang=js"
import style0 from "./swiperAdd.vue?vue&type=style&index=0&id=3f461b15&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f461b15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f461b15')) {
      api.createRecord('3f461b15', component.options)
    } else {
      api.reload('3f461b15', component.options)
    }
    module.hot.accept("./swiperAdd.vue?vue&type=template&id=3f461b15&scoped=true", function () {
      api.rerender('3f461b15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/swiperSet/swiperAdd.vue"
export default component.exports